import { z } from "zod";
import {
  DTOStorybookAccessTokenResponse,
  DTOStorybookUploadStatus,
  DTOStorybookUploadUrlRequest,
  DTOStorybookUploadUrlResponse,
} from "../../dto";
import { RequestExecutor } from "../../transport";

export class StorybookHostingEndpoint {
  constructor(private readonly requestExecutor: RequestExecutor) {}

  getSignedUploadUrl(dsId: string, body: DTOStorybookUploadUrlRequest): Promise<DTOStorybookUploadUrlResponse> {
    return this.requestExecutor.json(`/design-systems/${dsId}/storybook/upload`, DTOStorybookUploadUrlResponse, {
      body,
      method: "POST",
    });
  }

  delete(dsId: string, storybookUploadId: string): Promise<{ ok: boolean }> {
    return this.requestExecutor.json(
      `/design-systems/${dsId}/storybook/${storybookUploadId}`,
      z.object({ ok: z.boolean() }),
      {
        method: "DELETE",
      }
    );
  }

  getUploadStatus(dsId: string, storybookUploadId: string) {
    return this.requestExecutor.json(
      `/design-systems/${dsId}/storybook/${storybookUploadId}/status`,
      DTOStorybookUploadStatus
    );
  }

  getAccessToken(dsId: string, name: string) {
    return this.requestExecutor.json(
      `/design-systems/${dsId}/storybook/alias/${name}/access-token`,
      DTOStorybookAccessTokenResponse
    );
  }
}
